import { apiJson, apiJsonArray, authBearerOnly } from '@/lib/api-client';
import { getApiEndpoint, getApiMediaUrl } from '@/config/api';

export interface DevelopmentFaq {
  id: number;
  development_id: number;
  question: string;
  answer_html: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface DevelopmentFaqInput {
  question: string;
  answer_html: string;
  sort_order?: number;
  is_active?: boolean;
}

export class DevelopmentFaqService {
  static async listPublic(developmentId: number): Promise<DevelopmentFaq[]> {
    return apiJsonArray<DevelopmentFaq>(
      `api/developments/${developmentId}/faqs`,
    );
  }

  static async listAdmin(developmentId: number): Promise<DevelopmentFaq[]> {
    return apiJsonArray<DevelopmentFaq>(
      `api/developments/${developmentId}/faqs/admin`,
    );
  }

  static async create(
    developmentId: number,
    data: DevelopmentFaqInput,
  ): Promise<DevelopmentFaq> {
    return apiJson<DevelopmentFaq>(
      `api/developments/${developmentId}/faqs`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
    );
  }

  static async update(
    developmentId: number,
    faqId: number,
    data: Partial<DevelopmentFaqInput>,
  ): Promise<DevelopmentFaq> {
    return apiJson<DevelopmentFaq>(
      `api/developments/${developmentId}/faqs/${faqId}`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
    );
  }

  static async delete(
    developmentId: number,
    faqId: number,
  ): Promise<void> {
    await apiJson(`api/developments/${developmentId}/faqs/${faqId}`, {
      method: 'DELETE',
    });
  }

  static async uploadFaqImage(
    developmentId: number,
    file: File,
  ): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('developmentId', String(developmentId));

    const response = await fetch(getApiEndpoint('api/upload/faq-image'), {
      method: 'POST',
      headers: authBearerOnly(),
      body: formData,
    });

    const data = (await response.json()) as {
      filename?: string;
      path?: string;
      error?: string;
    };

    if (!response.ok) {
      throw new Error(data.error || 'Falha ao enviar imagem');
    }

    const filename = data.filename;
    if (!filename) {
      throw new Error('Resposta de upload inválida');
    }
    return getApiMediaUrl(
      'developments-faq',
      String(developmentId),
      encodeURIComponent(filename),
    );
  }
}
